<template>
    <v-container>
      <v-row>
        <v-col cols="12" md="12" class="pa-6 text-left text-justify">
            <div class="my-6">
                <p class="text--primary">
                    <TextHeading :level=3>Fundusze Europejskie 2021-2027</TextHeading>
                </p>
                
                <span v-for="(paragraph, i) in paragraphs"
                    :key="i">
                    <p class="text--primary">
                        <TextHeading :level=5>{{ paragraph.title }}</TextHeading>
                    </p>
                    <span v-for="(section, j) in paragraph.sections" :key="j">
                        <div v-if="section.type == 'paragraph'" class="text-body-1 text--primary" v-html="section.text"></div>
                        <p v-if="section.type == 'special_paragraph'" class="text--primary">
                            <TextHeading :level=6>{{ section.text }}</TextHeading>
                        </p>
                        <span v-if="section.type == 'list'">
                            <div class="text-body-1 text--primary" v-html="section.text"></div>
                            <v-list :dense="section.dense" disabled>
                                <v-list-item
                                    v-for="(point, k) in section.points"
                                    :key="k"
                                >
                                    <v-list-item-icon>
                                        <v-icon>{{ section.icon }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title class="text-body-1 text--primary text-wrap font-weight-regular"><span v-html="point"></span></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </span>
                        
                        <br />
                    </span>
                </span>
            </div>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="6" md="6">
            <v-img
                src="@/assets/eu_funds_2021-2027.png"
            >
                <template v-slot:placeholder>
                    <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                    >
                        <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                        ></v-progress-circular>
                    </v-row>
                </template>
            </v-img>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import TextHeading from "@/modules/TextHeading";
  export default {
  
    components: {TextHeading},

    data: () => ({
        paragraphs: [
            {
                title: "Środki unijne dla Polski w nowej perspektywie finansowej na lata 2021-2023",
                sections: [
                    {
                        text: "Polska otrzyma z budżetu Unii Europejskiej łącznie ok. 770 mld zł. Środki unijne w nowej perspektywie finansowej na lata 2021-2027 zostaną przeznaczone między innymi na badania, innowacje, przedsiębiorczość, infrastrukturę, klimat i ochronę środowiska, energetykę, cyfryzację, edukację i sprawy społeczne.",
                        type: "paragraph"
                    },
                    {
                        text: "Podobnie jak w latach 2014-2020 również w nowej perspektywie finansowej funduszy europejskich około 60% funduszy z polityki spójności trafi do programów realizowanych na poziomie krajowym. Pozostałe 40% otrzymają programy regionalne, zarządzane przez Marszałków województw.",
                        type: "paragraph"
                    },
                ]
            },
            {
                title: "Regionalne Programy Operacyjne to teraz Fundusze Europejskie:",
                sections: [
                    {
                        text: "Podziału funduszy na programy regionalne dokonano według algorytmu opartego na obiektywnych kryteriach, między innymi na liczbie ludności i PKB na mieszkańca. Najwięcej środków otrzyma województwo śląskie, najmniej natomiast województwo lubuskie.",
                        type: "paragraph"
                    },
                    {
                        text: "Zgodnie z zaleceniami Komisji Europejskiej odnośnie nowego podejścia do polityki informacyjnej dotyczącej Funduszy Europejskich nie będzie już stosowana dotychczasowa nazwa „Regionalne Programy Operacyjne”, a zastąpi ją krótsza „Fundusze Europejskie”.",
                        type: "paragraph"
                    },
                    {
                        text: "W ramach programów regionalnych przedsiębiorstwa otrzymają możliwość dofinansowania na zwiększenie potencjału w zakresie badań, innowacji oraz cyfryzacji, a także rozwój i wzrost konkurencyjności małych i średnich firm.",
                        type: "paragraph"
                    },
                    {
                        text: "Bardzo ważne będzie także wsparcie przedsiębiorstw w zakresie rozwoju OZE i efektywności energetycznej.",
                        type: "paragraph"
                    },
                    {
                        text: "W ramach realizowanych w nowej perspektywie finansowej 2021-2027 programów regionalnych,  przedsiębiorstwa będą mogły uzyskać wsparcie m.in. na:",
                        type: "list",
                        icon: "mdi-circle-medium",
                        dense: true,
                        points: [
                            "Prowadzenie działalności B+R;",
                            "Wdrożenie innowacji i wyników prac B+R;",
                            "Tworzenie i rozwój zaplecza B+R przedsiębiorstw;",
                            "Wsparcie cyfryzacji;",
                            "Wsparcie internacjonalizacji;",
                            "Wsparcie na zakup usług doradczych;",
                            "Projekty w zakresie efektywności energetycznej;",
                            "Instalacje OZE na potrzeby własne przedsiębiorstw;",
                            "Szkolenia, doradztwo oraz studia dla pracowników;",
                            "Szkolenia i doradztwo dla właścicieli i kadry zarządzającej przedsiębiorstw.",
                        ]
                    }
                ]
            },
            {
                title: "Wsparcie na poziomie krajowym",
                sections: [
                    {
                        text: "Jeżeli chodzi o środki na poziomie krajowym, to na lata 2021-2027 przedsiębiorcy mogą upatrywać szans w następujących programach:",
                        type: "paragraph"
                    },

                    {
                        text: "1. Program Fundusze Europejskie dla Nowoczesnej Gospodarki (następca Programu Operacyjnego Inteligentny Rozwój):",
                        type: "special_paragraph"
                    },
                    {
                        text: "W Europejskim Rankingu Innowacyjności 2021 (ERI 2021) Polska pozostaje krajem określanym mianem emerging innovator (wschodzący innowatorzy - najsłabsza grupa ze wskaźnikiem innowacyjności wynoszącym poniżej 70% średniej). Polska zajmuje 24 pozycję pod względem innowacyjności na 27 państw uwzględnionych w rankingu. Ciągłej poprawy wymagają nadal przede wszystkim wskaźniki należące do najgorzej ocenionych wymiarów takich jak: atrakcyjność systemu badawczego, czy innowatorzy.",
                        type: "paragraph"
                    },
                    {
                        text: "W związku z powyższym FENG za podstawowe wyzwania, którym należy sprostać obrał sobie:",
                        type: "list",
                        icon: "mdi-circle-medium",
                        dense: true,
                        points: [
                            "Wyzwania związane z rozwojem gospodarczym i innowacyjnością;",
                            "Wyzwania związane z Europejskim Zielonym Ładem;",
                            "Wyzwania związane z cyfryzacją, Przemysłem 4.0;",
                            "Wyzwania wskazane w Country Specific Recommendations;",
                            "Wyzwania związane z rozwojem regionalnym.",
                        ]
                    },
                    {
                        text: "Odpowiedzią na te wyzwania mają być projekty z zakresu dwóch utworzonych w ramach tego programu priorytetów:",
                        type: "paragraph"
                    },
                    {
                        text: "<b>Priorytet 1.</b> Wsparcie dla przedsiębiorców, do którego zaliczać się będą projekty z zakresu:",
                        type: "list",
                        icon: "mdi-circle-medium",
                        dense: true,
                        points: [
                            "Prac B+R;",
                            "Rozwoju infrastruktury B+R;",
                            "Wdrożeń wyników badań;",
                            "Internacjonalizacji rozumianej jako finansowanie wydatków związanych z promocją zagraniczną i dotyczących m.in.: komercjalizacji wyników prac B+R zagranicą, udziału w międzynarodowych łańcuchach dostaw, udziału w globalnym rynku zamówień publicznych oraz współpracy międzynarodowej;",
                            "Zapewnieniu usług w obszarze uzyskania i realizacji ochrony praw własności intelektualnej, w tym w szczególności własności przemysłowej;",
                            "Rozwoju kompetencji pracowników i osób zarządzających przedsiębiorstwem;",
                            "Cyfryzacji przedsiębiorstw;",
                            "„Zazieleniania” przedsiębiorstw.",
                        ]
                    },
                    {
                        text: "<b>Priorytet 2.</b> Środowisko sprzyjające innowacjom, w ramach którego realizowane będą projekty dotyczące:",
                        type: "list",
                        icon: "mdi-circle-medium",
                        dense: false,
                        points: [
                            "Zwiększenia zdolności sektora nauki do współpracy (Międzynarodowe Agendy Badawcze, projekty teamowe, współpraca najlepszych zespołów badawczych w formie konsorcjów w wybranych obszarach strategicznych, wsparcie infrastruktury organizacji badawczych, przeznaczonej do realizacji prac badawczych na rzecz gospodarki);",
                            "Wsparcia projektów i przedsięwzięć wyselekcjonowanych na poziomie Unii Europejskiej (finansowanie projektów przedsiębiorstw, które otrzymały certyfikat Seal of Excellence, wsparcie projektów IPCEI, finansowanie wkładu krajowego w konkursach na projekty badawczo-rozwojowe, finansowanie projektów realizowanych przez polskich partnerów w obszarach krajowych inteligentnych specjalizacji m.in. w ramach partnerstw ponadnarodowych S3 z regionami i krajami UE i spoza UE lub w ramach współpracy w grupie V4+);",
                            "Alternatywnych metod finansowania i realizacji prac B+R (wspólne przedsięwzięcia badawcze, transfer technologii pochodzących z organizacji badawczych, granty na Eurogranty, innowacyjne zamówienia publiczne.",
                        ]
                    },

                    {
                        text: "2. Program Fundusze Europejskie na Infrastrukturę, Klimat, Środowisko (następca Programu Infrastruktura i Środowisko):",
                        type: "special_paragraph"
                    },
                    {
                        text: "Głównym celem Programu jest poprawa warunków rozwoju kraju poprzez m.in. budowę infrastruktury technicznej zgodnie z założeniami rozwoju zrównoważonego, w tym poprzez np.:",
                        type: "list",
                        icon: "mdi-circle-medium",
                        dense: true,
                        points: [
                            "Obniżenie emisyjności gospodarki transformację w kierunku gospodarki przyjaznej środowisku i o obiegu zamkniętym;",
                            "Budowę efektywnego i odpornego systemu transportowego o jak najniższym negatywnym wpływie na środowisko naturalne.",
                        ]
                    },
                    {
                        text: "Przyglądając się dokładniej temu Programowi, to warto zwrócić uwagę na kierunki, które dedykowane będą również sektorowi przedsiębiorstw, a należeć do nich będą w szczególności:",
                        type: "list",
                        icon: "mdi-circle-medium",
                        dense: false,
                        points: [
                            "Cel szczegółowy 2.1 Wspieranie efektywności energetycznej i redukcji emisji gazów Cieplarnianych, w ramach którego dla sektora przemysłu i usług wsparcie skierowane będzie na modernizację energetyczną budynków zakładowych, podniesienie efektywności energetycznej procesów wytwórczych, zwiększenie efektywności energetycznej systemów obiegu mediów w zakładzie (np. systemu zimnej lub gorącej wody, systemu sprężonego powietrza lub systemu wentylacji), ciągów transportowych i zwiększanie efektywności energetycznej systemów pomocniczych, w tym np. kotłowni, układów odzysku ciepła z procesów przemysłowych lub oświetlenia oraz instalację urządzeń OZE;",
                            "Cel szczegółowy 2.6 Wspieranie transformacji w kierunku gospodarki o obiegu zamkniętym i gospodarki zasobooszczędnej, w ramach którego wspierane będą projekty dotyczące m.in. ponownego użycia, naprawy, wymiany rzeczy używanych. Tworzone będą instalacje do recyklingu i odzysku, jako procesów zagospodarowania najbardziej oczekiwanych w hierarchii sposobów postępowania z odpadami;",
                            "Cel szczegółowy 2.1 Wspieranie efektywności energetycznej i redukcji emisji gazów cieplarnianych, gdzie inwestycja powinna dotyczyć rozwoju skojarzonej produkcji energii elektrycznej i ciepła w procesie wysokosprawnej kogeneracji (w tym także energii elektrycznej, ciepła i chłodu w procesie trigeneracji) oraz rozwoju systemów ciepłowniczych i chłodniczych, w tym także magazynów ciepła;",
                            "Cel szczegółowy 2.2 Wspieranie energii odnawialnej zgodnie z dyrektywą (UE) 2018/2001, w tym określonymi w niej kryteriami zrównoważonego rozwoju, gdzie wsparcie będzie dotyczyło instalacji do produkcji energii elektrycznej, instalacji do produkcji ciepła oraz wytwarzania paliw alternatywnych z OZE wraz z magazynami energii działającymi na potrzeby danego źródła OZE oraz przyłączeniem do sieci. Elementem uzupełniającym projektu mogą być działania edukacyjno-informacyjne dotyczące zielonej energii.",
                        ]
                    },

                    {
                        text: "3. Program Fundusze Europejskie na Rozwój Cyfrowy (następca Programu Polska Cyfrowa):",
                        type: "special_paragraph"
                    },
                    {
                        text: "Celem programu Fundusze Europejskie na Rozwój Cyfrowy 2021-2027 (FERC) jest wsparcie transformacji cyfrowej kraju poprzez realizację przedsięwzięć, które zapewnią: szeroki dostęp do ultra-szybkiego Internetu, efektywne i przyjazne użytkownikom zaawansowane e-usługi publiczne, skuteczne działanie krajowego systemu cyberbezpieczeństwa, dostęp do danych o znaczącym potencjale do dalszego ich wykorzystywania, wsparcie rozwoju umiejętności cyfrowych oraz rozwiną współpracę międzysektorową na rzecz cyfrowych rozwiązań problemów społeczno-gospodarczych.",
                        type: "paragraph"
                    },
                    {
                        text: "Do celów tego Programu zalicza się:",
                        type: "list",
                        icon: "mdi-circle-medium",
                        dense: true,
                        points: [
                            "Budowa społeczeństwa gigabitowego w Polsce;",
                            "Udostepnienie zaawansowanych e-usług pozwalających w pełni na elektroniczne załatwienie spraw obywateli i przedsiębiorców (4 i 5 stopień e-dojrzałości usług);",
                            "Zapewnienie cyberbezpieczeństwa poprzez wsparcie w ramach nowego dedykowanego obszaru interwencji;",
                            "Rozwój gospodarki opartej na danych wykorzystującej najnowsze technologie cyfrowe;",
                            "Rozwój współpracy na rzecz tworzenia cyfrowych rozwiązań problemów społeczno-gospodarczych;",
                            "Wsparcie rozwoju zaawansowanych kompetencji cyfrowych, w tym również w obszarze cyberbezpieczenstwa dla jst i przedsiębiorców.",
                        ]

                    },
                    {
                        text: "Pandemia SARS-CoV-2 pokazała jak istotny jest szybki rozwój ww. obszarów dla sprawnego funkcjonowania gospodarki i społeczeństw w czasie tego typu zagrożeń. To dzięki procesowi cyfryzacji możliwa jest zdalna praca i edukacja, korzystanie z e-usług publicznych, w tym usług zdrowotnych, a także robienie zakupów czy załatwianie spraw w banku bez wychodzenia z domu.",
                        type: "paragraph"
                    },
                    {
                        text: "Odpowiadając na powyższe wyzwania w ramach Programu zaproponowano utworzenie dwóch priorytetów:",
                        type: "paragraph"
                    },
                    {
                        text: "<b>Priorytet I:</b> Zwiększenie dostępu do ultra-szybkiego Internetu szerokopasmowego, w ramach którego planuje się:",
                        type: "list",
                        icon: "mdi-circle-medium",
                        dense: true,
                        points: [
                            "Zwiększenie dostępu do ultra-szybkiego Internetu szerokopasmowego. Interwencja umożliwi objęcie zasięgiem m.in. przedsiębiorstw siecią o przepustowości co najmniej 100 Mb/s, przy czym wspierane będą wyłącznie rozwiązania technologiczne zapewniające skalowalność sieci do prędkości gigabitowych. W ramach interwencji wsparciem będą objęte projekty w zakresie budowy, rozbudowy lub przebudowy sieci dostępowych. Przewiduje się możliwość wsparcia rozwoju nowoczesnych technologii i systemów łączności zapewniających przepływ wielkich wolumenów danych z bardzo małymi opóźnieniami."
                        ]
                    },
                    {
                        text: "<b>Priorytet II:</b> Zaawansowane usługi cyfrowe, gdzie dla sektora przedsiębiorców przewidziano m.in.:",
                        type: "list",
                        icon: "mdi-circle-medium",
                        dense: false,
                        points: [
                            "Cyfrową dostępność i ponowne wykorzystanie informacji. Interwencja obejmie projekty, których celem będzie zapewnienie dostępu do dynamicznych zbiorów danych za pośrednictwem interfejsów programowania aplikacji, wykorzystywanie danych i analityki biznesowej w przedsiębiorstwach oraz wsparcie wzajemnego dzielenia się danymi przez przedsiębiorstwa, w tym poprzez opracowanie standardów współpracy w zakresie organizacyjnym, technicznym i prawnym. Promowane będzie również udostępnianie danych prywatnych instytucjom publicznym i podmiotom systemu szkolnictwa wyższego i nauki w celu realizacji interesu publicznego;",
                            "Wsparcie umiejętności cyfrowych. Wyzwaniem dla perspektywy finansowej 2021-27 jest zaspokojenie rosnącego zapotrzebowania, w szczególności na zaawansowane kompetencje cyfrowe, z takich obszarów, jak np.: analiza danych i uczenie maszynowe, robotyka i sensory, e-handel, cyberbezpieczeństwo, Internet rzeczy, obliczenia kwantowe, czy zarządzanie IT. Interwencja obejmie uruchomienie szkoleń dotyczących m.in. cyfryzacji gospodarki, przemysłu 4.0 (czy ogólnie: współczesnych trendów rozwojowych) dla m.in. przedsiębiorców w zakresie cyberbezpieczeństwa."
                        ]
                    },

                    {
                        text: "4. Program Fundusze Europejskie dla Polski Wschodniej (następca Programu Polska Wschodnia):",
                        type: "special_paragraph"
                    },
                    {
                        text: "To kontynuacja wsparcia dla 5 wschodnich województw, aby przyspieszyć ich rozwój. Nowością jest włączenie do programu części Mazowsza - bez Warszawy i przyległych powiatów - czyli regionu statystycznego mazowieckiego regionalnego.",
                        type: "paragraph"
                    },
                    {
                        text: "Opracowanie dedykowanego programu dla PW, stanowi wyraz konsekwentnego podejścia do wsparcia najsłabiej rozwiniętej części kraju.",
                        type: "paragraph"
                    },
                    {
                        text: "Głównym celem programu jest utrwalenie warunków sprzyjających konkurencyjności makroregionu oraz wyższej jakości życia w Polsce Wschodniej. Cele szczegółowe programu to:",
                        type: "list",
                        icon: "mdi-circle-medium",
                        dense: true,
                        points: [
                            "Wzmacnianie konkurencyjności i innowacyjności przedsiębiorstw;",
                            "Wzmacnianie atrakcyjności osadniczej miast i podniesienie jakości życia mieszkańców w dobie zmian klimatu;",
                            "Zwiększenie dostępności transportowej makroregionu;",
                            "Wzrost wykorzystania potencjału turystyki i uzdrowisk dla rozwoju.",
                        ]
                    },
                    {
                        text: "W programie przewidziano wsparcie w kilku obszarach, jednak jeden z nich jest szczególnie dedykowany przedsiębiorcom. Poziom rozwoju przedsiębiorczości w PW+ jest stosunkowo niski na tle kraju, co potwierdza m.in. liczba przedsiębiorstw na 1 tys. mieszkańców w PW+ (2020 r.) - 76% średniej krajowej. Przedsiębiorstwa z PW+ osiągają też słabsze efekty finansowe (niższą wartość produkcji sprzedanej na mieszkańca, niższe od średniej przychody na przedsiębiorstwo). Problemem jest niska innowacyjność przedsiębiorstw, niedostateczny zasób środków trwałych oraz niski poziom aktywności inwestycyjnej.",
                        type: "paragraph"
                    },
                    {
                        text: "W ramach tego obszaru przewidziano następujące rodzaje działań:",
                        type: "list",
                        icon: "mdi-circle-medium",
                        dense: true,
                        points: [
                            "Wsparcie start-upów;",
                            "Wykorzystanie procesów wzorniczych w MŚP;",
                            "Automatyzacja i robotyzacja MŚP;",
                            "Transformacja modeli biznesowych w kierunku Gospodarki Obiegu Zamkniętego;",
                            "Pożyczki dla MŚP - inwestycje w turystykę.",
                        ]
                    },

                    {
                        text: "5. Program Fundusze Europejskie dla Rozwoju Społecznego (następca Programu Wiedza Edukacja Rozwój):",
                        type: "special_paragraph"
                    },
                    {
                        text: "W programie FERS będzie realizowane wsparcie na rzecz m.in. poprawy sytuacji osób na rynku pracy, zwiększenia dostępności dla osób ze szczególnymi potrzebami, zapewnienia opieki nad dziećmi, podnoszenia jakości edukacji i rozwoju kompetencji, integracji społecznej, rozwoju usług społecznych i ekonomii społecznej oraz ochrony zdrowia.",
                        type: "paragraph"
                    },
                    {
                        text: "Odnosząc się stricte do sektora przedsiębiorstw, to w ramach tego programu warto zwrócić uwagę na m.in.:",
                        type: "paragraph"
                    },
                    {
                        text: "Lepsze polityki dla rozwoju społecznego:",
                        type: "list",
                        icon: "mdi-circle-medium",
                        dense: false,
                        points: [
                            "Wspieranie zrównoważonego pod względem płci uczestnictwa w rynku pracy, równych warunków pracy oraz lepszej równowagi między życiem zawodowym a prywatnym, w tym poprzez dostęp do przystępnej cenowo opieki nad dziećmi i osobami wymagającymi wsparcia w codziennym funkcjonowaniu;",
                            "Wspieranie dostosowania pracowników, przedsiębiorstw i przedsiębiorców do zmian, wspieranie aktywnego i zdrowego starzenia się oraz zdrowego i dobrze dostosowanego środowiska pracy, które uwzględnia zagrożenia dla zdrowia;",
                            "Wspieranie uczenia się przez całe życie, w szczególności elastycznych możliwości podnoszenia i zmiany kwalifikacji dla wszystkich, z uwzględnieniem umiejętności w zakresie przedsiębiorczości i kompetencji cyfrowych, lepsze przewidywanie zmian i zapotrzebowania na nowe umiejętności na podstawie potrzeb rynku pracy, ułatwianie zmian ścieżki kariery zawodowej i wspieranie mobilności zawodowej;",
                            "Wspieranie aktywnego włączenia społecznego w celu promowania równości szans, niedyskryminacji i aktywnego uczestnictwa, oraz zwiększanie szans zatrudnienia, w szczególności grup w niekorzystnej sytuacji.",
                        ]
                    },

                    {
                        text: "6. Program Fundusze Europejskie dla Rybactwa (następca Programu RYBY):",
                        type: "special_paragraph"
                    },
                    {
                        text: "Program Fundusze Europejskie dla Rybactwa jest instrumentem wsparcia sektorów rybactwa i gospodarki morskiej w Polsce. Program ten jest współfinansowany ze środków Europejskiego Funduszu Morskiego, Rybackiego i Akwakultury (EFMRA) wchodzącego w skład Europejskich Funduszy Strukturalnych i Inwestycyjnych (EFSI). Program zaprojektowany został z myślą o płynnej kontynuacji wparcia udzielanego sektorowi rybactwa w perspektywie finansowej UE 2014-2020, kiedy to środki z Europejskiego Funduszu Morskiego i Rybackiego wdrażane były za pośrednictwem Programu Operacyjnego „Rybactwo i Morze”.",
                        type: "paragraph"
                    },
                    {
                        text: "Program skierowany jest m.in. do:",
                        type: "list",
                        icon: "mdi-circle-medium",
                        dense: true,
                        points: [
                            "Podmiotów prowadzących działalność w zakresie rybołówstwa morskiego, rybołówstwa śródlądowego, chowu i hodowli ryb, przetwarzania i obrotu produktami rybołówstwa i akwakultury;",
                            "Konsorcjów przedsiębiorców z instytutami naukowo-badawczymi."
                        ]
                    },
                    {
                        text: "W ramach niniejszego Programu w kontekście prowadzenia działalności gospodarczej warto zwrócić uwagę na następujące założenia:",
                        type: "list",
                        icon: "mdi-circle-medium",
                        dense: false,
                        points: [
                            "Cel szczegółowy 1.1. Wzmocnienie działalności połowowej zrównoważonej pod względem gospodarczym, społecznym i środowiskowym (kapitał ludzki, innowacje, dywersyfikacja działalności rybackiej, inwestycje w portach);",
                            "Cel szczegółowy 1.2 Zwiększenie efektywności energetycznej i zmniejszenie emisji CO2 poprzez wymianę lub modernizację silników statków rybackich (zwiększenie efektywności energetycznej i zmniejszenie emisji CO2, operacje związane z wymianą i modernizacją silników na statkach rybackich;",
                            "Cel szczegółowy 1.3 Propagowanie dostosowania zdolności połowowej do uprawnień do połowów w przypadkach trwałego zaprzestania działalności połowowej i przyczynianie się do zapewnienia odpowiedniego poziomu życia w przypadkach tymczasowego zaprzestania działalności połowowej (trwałe zaprzestanie działalności połowowej, tymczasowe zaprzestanie działalności połowowej, mechanizm interwencyjny);",
                            "Cel szczegółowy 2.1 Propagowanie zrównoważonej działalności w zakresie akwakultury, w szczególności zwiększanie konkurencyjności produkcji akwakultury przy zapewnieniu, aby działalność ta była zrównoważona środowiskowo w perspektywie długoterminowej (przejmowanie, nabywanie lub zakładanie przez młodego rybaka gospodarstwa rybackiego oraz operacje, których celem jest wykształcenie specjalistów kierunków rybackich na potrzeby funkcjonowania gospodarstw rybackich, nauki i administracji, inwestycje i innowacje w akwakulturze, akwakultura środowiskowa, mechanizm interwencyjny);",
                            "Cel szczegółowy 2.2 Propagowanie wprowadzania do obrotu, jakości i wartości dodanej produktów rybołówstwa i akwakultury, a także przetwarzania tych produktów (Organizacje producentów, Inwestycje w przetwórstwie, Zmniejszenie oddziaływania przetwórstwa na środowisko, Świadomy konsument, mechanizm interwencyjny);",
                            "Cel szczegółowy 3.1 Sprzyjanie zrównoważonej niebieskiej gospodarce w obszarach przybrzeżnych, wyspiarskich i śródlądowych oraz wspieranie zrównoważonego rozwoju społeczności rybackich i sektora akwakultury (realizacja lokalnych strategii rozwoju i współpraca, wsparcie przygotowawcze, funkcjonowanie RLGD).",
                        ]
                    },

                    {
                        text: "7. Zupełnie nowy program - Fundusz Sprawiedliwej Transformacji:",
                        type: "special_paragraph"
                    },
                    {
                        text: "Fundusz Sprawiedliwej Transformacji (FST) ma trafić do sześciu regionów - śląskiego, dolnośląskiego, wielkopolskiego, lubelskiego, łódzkiego i małopolskiego. To województwa najbardziej narażone na skutki transformacji energetycznej.",
                        type: "paragraph"
                    },
                    {
                        text: "Fundusz ma pomóc ograniczyć negatywne skutki społeczne, gospodarcze oraz środowiskowe transformacji energetycznej. Będzie to nowe źródło finansowania dostępne w latach 2021-2027.",
                        type: "paragraph"
                    },
                    {
                        text: "Warunkiem ubiegania się o środki z FST jest przygotowanie regionalnych planów sprawiedliwej transformacji. Te plany mają pokazywać kierunki, na co te środki mają być przekazywane, jak regiony widzą swoją transformację energetyczną i jak powinniśmy likwidować jej negatywne skutki. Regiony są w trakcie przygotowania regionalnych planów transformacji.",
                        type: "paragraph"
                    },
                ]
            },
            // {
            //     title: "",
            //     sections: [
            //         {
            //             text: "",
            //             type: "paragraph"
            //         },
            //         {
            //             text: "",
            //             type: "special_paragraph"
            //         },
            //         {
            //             text: "",
            //             type: "list",
            //             icon: "",
            //             dense: false,
            //             points: [
                            
            //             ]
            //         },
            //     ]
            // }
        ]
    })
  }
  </script>